/* tslint:disable */
/* eslint-disable */
// <auto-generated>
//   Generated using custom tool!
// </auto-generated>

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { DefaultAxiosInstance } from './DefaultAxiosInstance';
import { Try } from 'framework/Try';
import { ILicenseInfoLicenseTypeAsEnum } from './ILicenseInfoLicenseTypeAsEnum';
import { INoahPropertiesServerType } from './INoahPropertiesServerType';

export async function configuration_Set(model: IConfigurationModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IResponse>> {
	try {
		let url_ = '/api/configuration/set';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(model);

		let options_ = <AxiosRequestConfig>{
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function configuration_Get(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConfigurationDto>> {
	try {
		let url_ = '/api/configuration/get';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function configuration_GetNoahInfo(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INoahProperties>> {
	try {
		let url_ = '/api/configuration/noahInfo/get';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function configuration_GetNoahLicense(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILicenseInfo>> {
	try {
		let url_ = '/api/configuration/noahLicense/get';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function controls_Close(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
	try {
		let url_ = '/api/controls/close';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function controls_Restart(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUnit>> {
	try {
		let url_ = '/api/controls/restart';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function info_Info(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IClientInfo>> {
	try {
		let url_ = '/api/info/clientInfo';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function info_MachineName(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
	try {
		let url_ = '/api/info/machineName';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function info_ClientId(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
	try {
		let url_ = '/api/info/clientId';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function force_set_patient(patientId: number, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
	try {
		let url_ = '/api/launch/force-set-patient/{patientId}';
		if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
		url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function launch_Module(
	moduleId: number,
	patientId: number,
	instance: AxiosInstance = DefaultAxiosInstance()
): Promise<Try<IModuleLaunchResponse>> {
	try {
		let url_ = '/api/launch/withModule/{moduleId}/{patientId}';
		if (moduleId === undefined || moduleId === null) throw new Error("The parameter 'moduleId' must be defined.");
		url_ = url_.replace('{moduleId}', encodeURIComponent('' + moduleId));
		if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
		url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function launch_WithAction(
	patientId: number,
	actionId: number,
	instance: AxiosInstance = DefaultAxiosInstance()
): Promise<Try<IModuleLaunchResponse>> {
	try {
		let url_ = '/api/launch/withAction/{patientId}/{actionId}';
		if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
		url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
		if (actionId === undefined || actionId === null) throw new Error("The parameter 'actionId' must be defined.");
		url_ = url_.replace('{actionId}', encodeURIComponent('' + actionId));
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function launch_WithSpecificModuleAndAction(
	moduleId: number,
	patientId: number,
	actionId: number,
	instance: AxiosInstance = DefaultAxiosInstance()
): Promise<Try<IModuleLaunchResponse>> {
	try {
		let url_ = '/api/launch/withModule/{moduleId}/{patientId}/{actionId}';
		if (moduleId === undefined || moduleId === null) throw new Error("The parameter 'moduleId' must be defined.");
		url_ = url_.replace('{moduleId}', encodeURIComponent('' + moduleId));
		if (patientId === undefined || patientId === null) throw new Error("The parameter 'patientId' must be defined.");
		url_ = url_.replace('{patientId}', encodeURIComponent('' + patientId));
		if (actionId === undefined || actionId === null) throw new Error("The parameter 'actionId' must be defined.");
		url_ = url_.replace('{actionId}', encodeURIComponent('' + actionId));
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_Get(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
	try {
		let url_ = '/api/meta/build';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_Ping(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<any>> {
	try {
		let url_ = '/api/meta/ping';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function modules_All(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IModuleSummaryWithIcon[]>> {
	try {
		let url_ = '/api/modules/all';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function status_CanLaunch(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
	try {
		let url_ = '/api/status/canLaunch';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function status_Get(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IStatus>> {
	try {
		let url_ = '/api/status/get';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function status_AutoFix(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IResponse>> {
	try {
		let url_ = '/api/status/autoFix';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function status_ExtendedStatus(requestUrl: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExtendedStatus>> {
	try {
		let url_ = '/api/status/status/extended?';
		if (requestUrl === undefined || requestUrl === null) throw new Error("The parameter 'requestUrl' must be defined and cannot be null.");
		else url_ += 'requestUrl=' + encodeURIComponent('' + requestUrl) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function status_CheckCredentials(requestUrl: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICheckStatus>> {
	try {
		let url_ = '/api/status/credentials/check?';
		if (requestUrl === undefined || requestUrl === null) throw new Error("The parameter 'requestUrl' must be defined and cannot be null.");
		else url_ += 'requestUrl=' + encodeURIComponent('' + requestUrl) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function status_CheckAssembly(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICheckStatus>> {
	try {
		let url_ = '/api/status/assembly/check';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function status_CheckNoahLicense(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICheckStatus>> {
	try {
		let url_ = '/api/status/noahLicense/check';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function status_FixAssembly(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IResponse>> {
	try {
		let url_ = '/api/status/assembly/fix';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function test_Throw(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
	try {
		let url_ = '/api/test/throw';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function test_Config(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
	try {
		let url_ = '/api/test/config/start';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function test_ConfigPath(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
	try {
		let url_ = '/api/test/config/path';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export interface IConfigurationModel {
	url: string | undefined;
	clientId: string | undefined;
	apiKey: string | undefined;
}

export interface IResponse {
	error: string | undefined;
	warning: string | undefined;
	hasError: boolean | undefined;
	hasWarning: boolean | undefined;
	isSuccess: boolean | undefined;
}

export interface IConfigurationDto {
	url: string | undefined;
	clientId: string | undefined;
	firstFourApiKeyChars: string | undefined;
	firstFourClientIdChars: string | undefined;
}

export interface INoahProperties {
	serverVersion: INoahVersion | undefined;
	clientVersion: INoahVersion | undefined;
	managedDbAssemblyName: string | undefined;
	modulesCanSetPatient: boolean | undefined;
	maxPublicBlobSize: number | undefined;
	maxPrivateBlobSize: number | undefined;
	maxFastViewBlobSize: number | undefined;
	actionConverterPackageVersion: number | undefined;
	serverType: INoahPropertiesServerType | undefined;
}

export interface INoahVersion {
	fileMajorPart: number | undefined;
	fileMinorPart: number | undefined;
	fileBuildPart: number | undefined;
	filePrivatePart: number | undefined;
	patchVersion: string | undefined;
}

export interface ILicenseInfo {
	daysLeft: number | undefined;
	licenseType: number | undefined;
	serialNumber: string | undefined;
	firstName: string | undefined;
	lastName: string | undefined;
	company: string | undefined;
	licenseTypeAsEnum: ILicenseInfoLicenseTypeAsEnum | undefined;
	blacklisted: boolean | undefined;
	suspicious: boolean | undefined;
	suspiciousExpireDate: Date | undefined;
}

export interface IUnit {}

export interface IClientInfo {
	machineName: string | undefined;
	clientId: string | undefined;
}

export interface IModuleLaunchResponse {
	modules: IModuleSummary[] | undefined;
	warning: string | undefined;
	error: string | undefined;
	mustSelectModule: boolean | undefined;
	hasWarning: boolean | undefined;
	hasError: boolean | undefined;
	isSuccess: boolean | undefined;
}

export interface IModuleSummary {
	moduleId: number | undefined;
	name: string | undefined;
	manufacturerCode: number | undefined;
	manufacturerName: string | undefined;
}

export interface IModuleSummaryWithIcon {
	moduleId: number | undefined;
	name: string | undefined;
	manufacturerCode: number | undefined;
	manufacturerName: string | undefined;
	base64Logo: string | undefined;
	hasLogo: boolean | undefined;
}

export interface IStatus {
	isRegistered: boolean | undefined;
	canReachServer: boolean | undefined;
	hasValidToken: boolean | undefined;
	isClientServiceRunning: boolean | undefined;
	isServerServiceRunning: boolean | undefined;
	canGetNoahProperties: boolean | undefined;
	hasCorrectDbAssembly: boolean | undefined;
	isLicenseExpired: boolean | undefined;
	errorCode: number | undefined;
	hasError: boolean | undefined;
}

export interface IExtendedStatus {
	checkCredentials: ICheckStatus | undefined;
	checkAssembly: ICheckStatus | undefined;
	checkNoahLicense: ICheckStatus | undefined;
	hasError: boolean | undefined;
}

export interface ICheckStatus {
	error: string | undefined;
	hasError: boolean | undefined;
}

export type CredentialsError =
	| 'NoRequestUrlProvided'
	| 'NoCredentials'
	| 'RequestUrlDoesNotMatchCredentialsUrl'
	| 'CannotReachServer'
	| 'NotRegistered'
	| 'InvalidApiToken';
export const CredentialsErrors: CredentialsError[] = [
	'NoRequestUrlProvided',
	'NoCredentials',
	'RequestUrlDoesNotMatchCredentialsUrl',
	'CannotReachServer',
	'NotRegistered',
	'InvalidApiToken',
];

export type AssemblyError = 'NotInstalled' | 'NoahServerNotRunning' | 'NoahClientNotRunning' | 'CannotGetNoahProps' | 'IncorrectDbAssembly';
export const AssemblyErrors: AssemblyError[] = ['NotInstalled', 'NoahServerNotRunning', 'NoahClientNotRunning', 'CannotGetNoahProps', 'IncorrectDbAssembly'];

export type NoahLicenseError = 'NotInstalled' | 'NoahServerNotRunning' | 'NoahClientNotRunning' | 'CannotGetLicenseInfo' | 'IncorrectLicense';
export const NoahLicenseErrors: NoahLicenseError[] = [
	'NotInstalled',
	'NoahServerNotRunning',
	'NoahClientNotRunning',
	'CannotGetLicenseInfo',
	'IncorrectLicense',
];
